<div class="containerData">
    <div style="width: 100%;">
        <span class="close2" (click)="close()">&times;</span>
    </div>
    <br>
    <div class="tituloData">{{data.strNombre}}</div>
    <div class="descripcionData"><b>{{data.decTarifa}}€</b></div>
    <br>
    <div class="descripcionData">{{data.strDescripcion}}</div>
    <br>
    <div class="cantidadData"> 
        <!-- <div class="menos" [disabled]="true">-</div> -->
        <div class="menos" (click)="rest()">-</div>
        {{cantidad}} 
        <!-- <div class="mas">+</div> -->
        <div class="mas" (click)="sum()">+</div>
    </div>
    <br>
    <div class="btnPedidoData">
        <button mat-raised-button color="warn" style="width: 100%;" (click)="addPedido()">Añadir al pedido {{precioTotal | number}} €</button>
    </div> 
</div>

